import { createReducer } from "sc/helpers/reducer";
import { LOGGED_IN, LOGOUT } from "../actions/auth";

export default createReducer(null, {
  [LOGGED_IN]: (state, action) => action.payload.user,
  [LOGOUT]: (state, action) => null,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/user-reducer.js